import { render, staticRenderFns } from "./mFooter.vue?vue&type=template&id=681eec3a&scoped=true"
import script from "./mFooter.vue?vue&type=script&lang=js"
export * from "./mFooter.vue?vue&type=script&lang=js"
import style0 from "./mFooter.vue?vue&type=style&index=0&id=681eec3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681eec3a",
  null
  
)

export default component.exports